import { Body2 } from '@xo-union/tk-ui-typography';
import { ToggleSwitch } from '@xo-union/tk-component-switches';
import React from 'react';
import { ChangeEvent } from 'react';
import { Section } from '../Section';
import styles from './SettingToggle.scss';
import { compose } from '@xo-union/react-css-modules';

interface SettingToggleProps {
  title: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  children?: React.ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  dataTestId?: string;
}

const SettingToggle = ({ title, subtitle, children, checked, onChange, dataTestId }: SettingToggleProps) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <Section>
      <ToggleSwitch
        labelDirection="left"
        labelBlock
        checked={checked}
        onChange={handleChange}
        data-testid={dataTestId}
        classes={compose({ container: styles.SettingToggle__ToggleSwitch__Container })}
      >
        {title}
      </ToggleSwitch>
      {!!subtitle && <Body2 className={styles.SettingToggle__Subtitle}>{subtitle}</Body2>}
      {children}
    </Section>
  );
};

export default SettingToggle;
